var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_documento",
    "data-name": "icona documento",
    transform: "translate(-240 -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(241 29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_166",
    "data-name": "Tracciato 166",
    d: "M11.12,15H1.875A1.877,1.877,0,0,1,0,13.125V1.875A1.877,1.877,0,0,1,1.875,0H10.4a1.877,1.877,0,0,1,1.875,1.875l.064,11.913a.512.512,0,0,1-.511.511.53.53,0,0,1-.575-.461V1.875a.853.853,0,0,0-.852-.852H1.875a.853.853,0,0,0-.852.852v11.25a.853.853,0,0,0,.852.852H11.12a.511.511,0,1,1,0,1.023Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_167",
    "data-name": "Tracciato 167",
    d: "M10.67,14.523H3.511a.511.511,0,1,1,0-1.023H10.67a.511.511,0,1,1,0,1.023Z",
    transform: "translate(-0.955 -4.295)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_168",
    "data-name": "Tracciato 168",
    d: "M10.67,10.523H3.511a.511.511,0,1,1,0-1.023H10.67a.511.511,0,1,1,0,1.023Z",
    transform: "translate(-0.955 -3.023)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_169",
    "data-name": "Tracciato 169",
    d: "M7.261,6.523H3.511a.511.511,0,1,1,0-1.023h3.75a.511.511,0,1,1,0,1.023Z",
    transform: "translate(-0.955 -1.75)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_765",
    "data-name": "Rettangolo 765",
    transform: "translate(240 29)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b3f4d2ce2b003eb064422712e7924d0f.svg";
export { ForwardRef as ReactComponent };